import { Component, Input, OnInit, EventEmitter, Output, ViewChild, NgZone, ChangeDetectorRef, AfterViewInit } from '@angular/core';

import * as _ from 'lodash';

@Component({
    selector: "iban",
    template: require('./iban.component.html'),
    styles: [require('./iban.component.css')]
})
export class IbanComponent implements OnInit {
    public tabIndex: number;
    public isAccNoValid: boolean;
    public isUserIbanValid: boolean;
    public isIbanGenerated: boolean;
    public isIbanValidated: boolean;
    public isIbanValid: boolean;
    public accNoPart1: number;
    public accNoPart2: number;
    public accNoPart3: number;
    public generatedIbanNumber: string;
    public userIbanNumber: string;
    public generatedAccountNumber: string;
    public userAccountNumber: number;

    countryCode: string = "AE";
    countryCodeEq: string = "1014";
    bankCode: string = "020";
    checkDigit: string = "00";

    constructor() {
    }
    ngOnInit() {

        window.location.href = "https://www.hsbc.ae/help/what-is-iban/";
        // this.initialiseObjects();
    }
    initialiseObjects() {
        this.tabIndex = 0;
        this.isAccNoValid = false;
        this.isUserIbanValid = false;
        this.isIbanGenerated = false;
        this.isIbanValidated = false;
        this.isIbanValid = false;
        this.generatedIbanNumber = "";
        this.userIbanNumber = "";
    }
    onAccNoKeyPress(event) {
        let pattern = /[0-9]/;
        let inputChar = String.fromCharCode(event.charCode);

        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }
    onIbanNoKeyPress(event) {
        let pattern = /^[a-zA-Z0-9]+$/;
        let inputChar = String.fromCharCode(event.charCode);

        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }
    checkIsAccNoValid() {
        this.isIbanGenerated = false;

        if (this.accNoPart1 && this.accNoPart2 && this.accNoPart3 &&
            this.accNoPart1.toString().length == 3 && this.accNoPart2.toString().length == 6 && this.accNoPart3.toString().length == 3) {
            this.isAccNoValid = true;
        } else {
            this.isAccNoValid = false;
        }
    }
    checkIsIbanNoValid() {
        this.isIbanValidated = false;

        if (this.userIbanNumber &&
            this.userIbanNumber.length <= 23) {
            this.isUserIbanValid = true;
        } else {
            this.isUserIbanValid = false;
        }
    }
    clearAccNo() {
        this.accNoPart1 = null;
        this.accNoPart2 = null;
        this.accNoPart3 = null;

        this.generatedIbanNumber = "";
        this.isIbanGenerated = false;
    }
    clearIbanNo() {
        this.userIbanNumber = "";
        this.generatedAccountNumber = "";
        this.isIbanValidated = false;
        this.isIbanValid = false;
    }
    generateIban() {
        let userAccountNumber = this.accNoPart1 + '' + this.accNoPart2 + '' + this.accNoPart3;

        let noLength = userAccountNumber.length;
        for (var i = 1; i <= 16 - noLength; i++) {
            userAccountNumber = "0" + userAccountNumber;
        }
        let tempIBAN: any = this.bankCode + userAccountNumber + this.countryCodeEq + "00";
        tempIBAN = tempIBAN.substring(0, 9) % 97 + "" + tempIBAN.substr(9);
        tempIBAN = tempIBAN.substring(0, 9) % 97 + "" + tempIBAN.substr(9);
        tempIBAN = tempIBAN.substring(0, 9) % 97 + "" + tempIBAN.substr(9);

        let mod97 = tempIBAN.substring(0, 9) % 97;

        let checkDigit: any = 98 - mod97;
        if (checkDigit / 10 < 1) {
            checkDigit = "0" + checkDigit;
        }
        let IBANNo = this.countryCode + checkDigit + this.bankCode + userAccountNumber;

        this.generatedIbanNumber = IBANNo;
        this.isIbanGenerated = true;
    }
    validateIban() {
        let iban = JSON.parse(JSON.stringify(this.userIbanNumber));

        iban = iban.replace(/\s/g, "");

        var countryCode = iban.substring(0, 2);
        var accNumber = iban.substring(11, 23);
        var bankCode = iban.substring(4, 7);
        var checkDigitV = iban.substring(2, 4);
        var countryCodeEq = "1014";
        var valid = false;

        var tempIBAN: any = bankCode + "0000" + accNumber + countryCodeEq + "00";
        tempIBAN = tempIBAN.substring(0, 9) % 97 + "" + tempIBAN.substr(9);
        tempIBAN = tempIBAN.substring(0, 9) % 97 + "" + tempIBAN.substr(9);
        tempIBAN = tempIBAN.substring(0, 9) % 97 + "" + tempIBAN.substr(9);

        var mod97 = tempIBAN.substring(0, 9) % 97;

        var checkDigit = 98 - mod97;

        if (iban == "") {
            valid = false;
            return false;
        } else if (countryCode != "AE" && countryCode != "ae") {
            valid = false;
        } else if (bankCode != "020") {
            valid = false;
        } else if (checkDigit != checkDigitV) {
            valid = false;
        } else {
            valid = true;
        }

        this.generatedAccountNumber = accNumber;
        this.isIbanValidated = true;
        this.isIbanValid = valid;
    }
    openFaQ() {
        window.open("https://www.hsbc.ae/1/2//common/iban-faq");
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/iban/iban.component.ts